module.exports = __webpack_public_path__ + "static/media/que-hacer-en-la-boca.7b04b0d0.md";